import classnames from "classnames";

import Button from "@/components/button/Button.tsx";
import {Plan} from "@/lib/types/billing.ts";
import {CustomRow} from "@/pages/billing/subscription/plan/CustomRow.tsx";
import {PlanRowAdditionalServices} from "@/pages/billing/subscription/plan/PlanRowAdditionalServices.tsx";
import {PlanRowStrategy} from "@/pages/billing/subscription/plan/PlanRowStrategy.tsx";
import {PlanRowTrainingSession} from "@/pages/billing/subscription/plan/PlanRowTrainingSession.tsx";
import {PlanRowUpro} from "@/pages/billing/subscription/plan/PlanRowUpro.tsx";

import css from "./PlanRegular.module.css";

export interface PlanCustomProps {
  handleCheckout: (plan: Plan) => void;
}

export const PlanCustom = ({handleCheckout}: PlanCustomProps) => {
  return (
    <>
      <div className={classnames("col white-block rounded rounded-3 white-block-border mt-6", css.PlanContainer)}>
        <div className={classnames("pt-3 pb-0 px-3", css.PlanHeading)}>
          <h2 className={classnames("fw-bold mb-1", css.PlanTitle)}>Your Plan, Your Way</h2>
          <div className={classnames(css.CustomPlanSubtitle, "mb-3 mb-xxl-2")}>
            Create a <strong>Custom</strong> monitoring plan <strong>that supports only what you require</strong>,
            nothing you don’t!
          </div>
        </div>
        <div className="px-3">
          <div className="text-center p-3 px-2">
            <div data-bs-toggle="tooltip">
              <Button variant={"marketingPrimary"} className="w-100" onClick={() => handleCheckout(Plan.Custom)}>
                Contact Us
              </Button>
            </div>
            <div className={classnames("mt-4 fw-bolder", css.PlanSubDescription)}>Custom Built for your Business!</div>
            <hr className="pulse-color-gray-500 border-2 my-2" />
            <CustomRow
              text="Any Configuration"
              tooltip="Support for any configuration and any scale that your business requires."
            />
            <CustomRow
              text="Flexible Billing"
              tooltip="Flexible billing that meets your business needs, such as invoiced payments and custom payment terms! We support it all!"
            />
            <CustomRow
              text="Volume Discounts"
              tooltip="Volume Discounts available with customized pricing  designed for growth and scale!"
            />
            <CustomRow
              text="Custom Terms"
              tooltip="Contact us for custom contract terms, multi-year contracts or specific contract requirements."
            />
            <CustomRow
              text="Customer Success Manager"
              tooltip="Get custom support, QBRs, strategy and more."
              className="mb-4"
            />
            <PlanRowAdditionalServices />
            <PlanRowStrategy plan={Plan.Custom} />
            <hr className="pulse-color-gray-500 border-2 my-2" />
            <PlanRowTrainingSession />
            <hr className="pulse-color-gray-500 border-2 my-2" />
            <PlanRowUpro plan={Plan.Custom} />
            <hr className="pulse-color-gray-500 border-2 my-2" />
          </div>
        </div>
      </div>
    </>
  );
};
